import { apiUrls } from '../../../utils/constants/urls'
import { removeEmptyParameters } from '../../../utils/queryParameters'
import toast from '../../elem/Toast'

const getInvoice = (authFetch, API_URL, invoiceId, after) => {
    authFetch(
        `${API_URL}/${apiUrls.invoice}/${invoiceId}`
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Invoice: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const getInvoiceSchema = (authFetch, API_URL, after) => {
    authFetch(
        `${API_URL}/${apiUrls.schema}/invoice`
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Schema: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const getInvoiceAutoCalc = (authFetch, API_URL, invoice, abortController, after) => {
    const queryParams = removeEmptyParameters(invoice)
    const POST = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
                'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
        },
        body: JSON.stringify(queryParams),
        signal: abortController.signal
    }  
    authFetch(
        `${API_URL}/${apiUrls.autoCalc}/invoice`,
        POST
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response)
        })
        .catch((e) => {
            if (e.name !== 'AbortError') {
                toast({
                    level: 'error',
                    message:
                        'Schema: ' +
                        (e.message
                            ? e.message
                            : 'Unable to connect to the server. Please try again later.'),
                })
            }
        })
}

const createInvoice = (authFetch, API_URL, invoice, after) => {
    const url = `${API_URL}/${apiUrls.invoice}/create`
    const POST = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
                'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
        },
        body: JSON.stringify(invoice)
    }  
    authFetch(
        url, POST
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            toast({
                level: 'success',
                message: response.message,
                alert: true
            })
            after(response.createdId)
            
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Create Invoice: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const updateInvoice = (authFetch, API_URL, invoice, after) => {
    const url = `${API_URL}/${apiUrls.invoice}` 
    const POST = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
                'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
        },
        body: JSON.stringify(invoice)
    }  
    authFetch(
        url, POST
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            toast({
                level: 'success',
                message: response.message,
                alert: true
            })
            after(response)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Update Invoice: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

export { getInvoice, getInvoiceSchema, createInvoice, updateInvoice, getInvoiceAutoCalc }
